/**
 * Contour Instance show — `[PROPOSED]` Inspector-grammar teaser at
 * `/contour-instances/:id`. Full grammar shell with the spec relations
 * (Artifact · Contour · ArtifactPositions · transitions · lifecycle) as
 * labeled-empty rows until `/api/contour-instances` ships. No primary verb
 * beyond inspection (runtime entity). Never hard-errors a show page.
 */
import { useParams } from "react-router-dom";

import {
  Inspector,
  InspectorHeader,
  InspectorSection,
  Field,
  FieldGrid,
  RelationsBlock,
  AuditBlock,
  TechnicalId,
} from "@/components/inspector";
import { ProposedShowTeaser, BackToList } from "../_shared/ProposedModule";

export function ContourInstanceShow() {
  const { id } = useParams<{ id: string }>();

  return (
    <Inspector>
      <InspectorHeader
        title="Contour Instance"
        subtitle="A live run of a contour over an artifact — its positions and lifecycle."
        status="proposed"
        actions={<BackToList to="/contour-instances" label="Contour instances" />}
      />

      <InspectorSection title="Overview">
        <FieldGrid>
          <Field label="Artifact" />
          <Field label="Contour" />
          <Field label="Lifecycle" />
          <Field label="Current phase" />
        </FieldGrid>
      </InspectorSection>

      <InspectorSection title="Body">
        <ProposedShowTeaser endpoint="/api/contour-instances" />
      </InspectorSection>

      <InspectorSection title="Relations">
        <RelationsBlock
          groups={[
            {
              title: "References",
              emptyMessage:
                "Artifact · Contour · ArtifactPositions appear once this ships.",
              items: [],
            },
            {
              title: "Transitions",
              emptyMessage: "Phase transitions appear once this ships.",
              items: [],
            },
          ]}
        />
      </InspectorSection>

      <InspectorSection title="Technical">
        <FieldGrid className="text-muted-foreground">
          <Field label="Id">
            <TechnicalId id={String(id)} />
          </Field>
        </FieldGrid>
      </InspectorSection>

      <InspectorSection title="Audit">
        <AuditBlock entityType="contour-instances" entityId={id} />
      </InspectorSection>
    </Inspector>
  );
}

export default ContourInstanceShow;
